import { CancelButton, SaveButton } from '@core/components/Buttons';
import { TextInput } from '@core/components/Inputs';
import { mensagemCampoObrigatorio } from '@core/util/mensagemUtil';
import { Grid, Typography } from '@material-ui/core';
import { cancelarAlert } from 'app/services/alerts';
import { FormikProvider, useFormik } from 'formik';
import React, { useEffect } from 'react';
import * as Yup from 'yup';
import DreList from '../DreList';
import categoriaItemStyles from './styles';

const tipo = {
  RECEITA: 'Receita',
  DESPESA: 'Despesa',
};

const FormClasseAdd = ({ classe, onAdd, dreList, onSuccess, onCancel }) => {
  const styles = categoriaItemStyles();

  const getInitialValues = (_classe) => ({
    nome: '',
    dre: _classe.dreId,
  });

  const initialErrors = {
    nome: '',
    dre: '',
  };

  const categoriaSchema = Yup.object().shape({
    nome: Yup.string()
      .required(mensagemCampoObrigatorio('a descrição.'))
      .min(3, 'É necessário informar pelo menos 3 caracteres no campo'),
    dre: Yup.string().nullable(),
  });

  const handleCancel = () => {
    const close = () => {
      formik.resetForm(getInitialValues(classe));
      onCancel();
    };

    if (formik.dirty) {
      cancelarAlert({
        confirmar: close,
      });
    } else {
      close();
    }
  };

  const handleAdd = async (data) => {
    const _classe = {
      nome: data.nome,
      dreId: data.dre,
      classePaiId: classe.id,
      natureza: classe.natureza,
      planoContasId: classe.planoContasId,
    };

    if (!formik.dirty) {
      formik.resetForm(getInitialValues(classe));
      onSuccess();
    } else {
      await onAdd(_classe);
    }
  };

  const formik = useFormik({
    validationSchema: categoriaSchema,
    onSubmit: handleAdd,
    initialValues: getInitialValues(classe),
    initialErrors,
  });

  useEffect(() => {
    formik.resetForm(getInitialValues(classe));
    // Efeito de montagem: incluir as dependências reexecutaria a carga inicial a cada render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const dentroDeText = `${tipo[classe.natureza]} dentro de ${classe.indice} ${classe.nome}`;

  return (
    <FormikProvider value={formik}>
      <div className={`${styles.corner} ${styles[`corner${classe.nivel + 1}`]}`} />
      <Typography variant="subtitle2" display="inline" className={styles.root}>
        {dentroDeText}
      </Typography>

      <form onSubmit={onAdd} className={styles.form}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} md={4} xl={3} ls={5}>
            <TextInput
              id="nome"
              name="nome"
              value={formik.values.nome}
              onChange={formik.handleChange}
              error={formik.errors.nome}
              touched={!!formik.errors.nome}
              helperText={formik.errors.nome}
              required
              label="Descrição"
              variant="outlined"
              autoFocus
              fullWidth
              maxLength={128}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={4} xl={5} ls={5}>
            <DreList
              id="dre"
              name="dre"
              selecionado={formik.values.dre}
              onChange={formik.handleChange}
              dres={dreList}
            />
          </Grid>
          <Grid item md={4} />
        </Grid>
        <div className={styles.containerButtons}>
          <CancelButton onClick={handleCancel}>Cancelar</CancelButton>
          <SaveButton id={`btn-add-${classe.id}`} onClick={formik.handleSubmit} type="button">
            Salvar
          </SaveButton>
        </div>
      </form>
    </FormikProvider>
  );
};

export default FormClasseAdd;
